import { render, staticRenderFns } from "./AppSectionColComponent.vue?vue&type=template&id=6151498b&scoped=true&"
import script from "./AppSectionColComponent.ts?vue&type=script&lang=ts&"
export * from "./AppSectionColComponent.ts?vue&type=script&lang=ts&"
import style0 from "./AppSectionColComponent.scss?vue&type=style&index=0&id=6151498b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6151498b",
  null
  
)

export default component.exports